import { Box, Stack } from "@mui/material";
import i18n from "src/i18n";

/**
 * Warehouse Tour Steps:
 * 0: body (Welcome)
 * 1: #warehouse-sidebar - Navigate to warehouse
 * 2: #warehouse-add-btn - Add warehouse button
 * 3: body (Completion)
 */
export const warehouseTourSteps = (isMobile, isScrollableDrawer) => [
    {
        target: "body",
        title: <Stack justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/hand-up.webp" />
            {i18n.t("tutorial.warehouseTour.title")}
        </Stack>,
        content: i18n.t("tutorial.warehouseTour.step1"),
        placement: "center",
    },
    {
        target: "#warehouse-sidebar",
        content: i18n.t("tutorial.warehouseTour.step2"),
        placement: "top",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },
    },
    {
        target: "#warehouse-add-btn",
        content: i18n.t("tutorial.warehouseTour.step3"),
        placement: "top",
    },
    {
        target: "body",
        title: <Box display="flex" justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/rocket.png" />
        </Box>,
        content: i18n.t("tutorial.warehouseTour.end"),
        placement: "center",
    },
];
